export default __webpack_public_path__ + "static/pokemon-a161b3cb222ee05c91dfa886513698c6.png";